export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#CEF6E9\"/><path d=\"M15.555 14.001h10.797l-.745 1.898-1.621 1.14-.669-.635-.99.636-.888-.636-.95.636-.875-.636-1.155 1.259h-2.657M10.32 14.97a1.206 1.206 0 01-.856 2.06 1.211 1.211 0 01-1.118-.744 1.206 1.206 0 011.118-1.67 1.212 1.212 0 01.856.354zm.349 6.025a5.004 5.004 0 005.008-5c0-2.762-2.242-5-5.008-5a5.004 5.004 0 00-5.009 5c0 2.761 2.243 5 5.009 5z\" stroke=\"#1D1D1B\" stroke-miterlimit=\"10\" stroke-linecap=\"square\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};